<template>
  <b-row>
    <b-col>
      <b-row style="margin-bottom:12px">
        <b-col cols="12" sm="5">
          <h2 style="margin-bottom:0">{{ title }}</h2>
          <h4 style="margin-top:0">Start: {{ startDate }}</h4>
        </b-col>
        <b-col cols="12" sm="7">
          <b-row no-gutters class="well-row" style="margin:12px 0">
            <b-col>
              <b-card class="well text-center" bg-variant="primary" footer="JAX">
                <b-card-text class="stat-text-big">{{ starCount }}</b-card-text>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="well text-center" bg-variant="dark" footer="Missions">
                <b-card-text class="stat-text">{{ effortCount }}</b-card-text>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="well text-center" bg-variant="info" footer="Duration">
                <b-card-text class="stat-text">{{ rideDuration }}</b-card-text>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="well text-center" bg-variant="danger" footer="Cal">
                <b-card-text class="stat-text">{{ calories }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>


      <b-row align-v="stretch">
        <!-- <b-col cols="6" md="3">
          <b-row>
            <b-col>
              <b-card bg-variant="primary" footer="JAX" class="text-center">
                <b-card-text class="stat-text-big">{{ starCount }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card bg-variant="info" footer="Duration" class="text-center">
                <b-card-text class="stat-text">{{ rideDuration }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="6" md="3">
          <b-row>
            <b-col>
              <b-card bg-variant="danger" footer="wh" class="text-center">
                <b-card-text class="stat-text">{{ calories }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card bg-variant="dark" footer="Missions" class="text-center">
                <b-card-text class="stat-text">{{ effortCount }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-col> -->

        <b-col>
          <b-table-lite
            striped
            responsive
            borderless
            hover
            tbody-tr-class="table-row"
            :items="rides"
            :fields="fields"
            @row-clicked="onRowClicked"
          >
          </b-table-lite>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BTableLite, BCard, BCardText } from "bootstrap-vue";
import utils from "../utils";
import { DateTime } from "luxon";

export default {
  name: "ActivityPeriod",
  components: { BTableLite, BCard, BCardText },
  props: ["period"],
  computed: {
    title() {
      return `Week ${this.start.toFormat("WW")}, ${this.start.toFormat("yyyy")}`;
    },
    startDate() {
      return this.start.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
    },
    start() {
      return DateTime.fromISO(this.period.startDate);
    },
    coinCount() {
      return this.period.coinCount || 0;
    },
    starCount() {
      return this.period.starCount || 0;
    },
    calories() {
      return utils.numberToStr(utils.whToCal(this.period.wattHrs) || 0);
    },
    effortCount() {
      return this.period.effortCount || 0;
    },
    isRideData() {
      return this.rides?.length > 0;
    },
    rides() {
      return this.period.rides.items || [];
    },
    rideDuration() {
      return (
        (this.period.rideDuration &&
          utils.durationStrFromSecs(this.period.rideDuration)) ||
        "--"
      );
    },
  },
  methods: {
    onRowClicked(item, index) {
      console.log(`Ride clicked: ${JSON.stringify(item)}. Index: ${index}.`);
      this.$router.push({ name: "rideDetails", params: { id: item.id } });
    },
  },
  data() {
    return {
      fields: [
        { key: "title", label: "Rides" },
        { key: "createdAt", label: "Day", formatter: utils.strToWeekdayLocale },
        { key: "duration", formatter: utils.timeStrFromSecs },
        { key: "wattHours", label: "Cal", formatter: (v) => utils.whToCal(v).toFixed(0) },
      ],
    };
  },
};
</script>

<style scoped>
.full-height {
  height: calc(100% - 60px);
  box-sizing: border-box;
}
.card {
  margin-top: 10px;
  margin-bottom: 10px;
}
.well {
  box-shadow: none;
  border-radius: 0;
  margin: 0;
}
.well-row {
  border-radius: 6px;
  overflow: hidden;
}
.well-row .col {
  padding: 0;
}
.well .card-body {
  padding: 6px 12px 6px 12px;
}
.well .card-footer {
  padding: 0 12px 6px 12px;
  text-align: center;
}
.stat-text {
  font-size: 18px;
  padding: 0;
  margin-top: 14px;
}
.stat-text-big {
  font-size: 28px;
  padding: 0;
  margin-top: 14px;
}
.table-title {
  margin: 0;
  margin-top: 10px;
  border-width: 1px 0;
  border-color: #5db361;
  color: #5db361;
  border-style: solid;
  text-transform: uppercase;
  text-align: right;
}
</style>